import React from 'react';
import { CallButton, CallButtonVariant } from '@naf/call-button';
import * as S from './CallButton.styles';

interface CallButtonSerializerProps {
  value: {
    phoneNumberToCall: string;
    text: string;
    variant: CallButtonVariant;
    withIcon: boolean;
  };
}

export const CallButtonBlock = ({
  value: { phoneNumberToCall, text, variant, withIcon },
}: CallButtonSerializerProps) => (
  <S.StyledCallButtonWrapper>
    <CallButton phoneNumberToCall={phoneNumberToCall} text={text} variant={variant} withIcon={withIcon} />
  </S.StyledCallButtonWrapper>
);

export const CallButtonBlockSerializer =
  () =>
  ({ value }: CallButtonSerializerProps) => <CallButtonBlock value={value} />;
